import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'calcRotate'
})
export class CalcRotatePipe implements PipeTransform {
  protected MIN_VALUE = -100;
  protected MAX_VALUE = 100;
  protected MIDDLE_VALUE = 50;
  protected ZERO_VALUE = 0;
  constructor() {}

  transform(value: number, valueList: any[]): number {
    if (Number.isFinite(value) && valueList[0]['nps']) {
      if (value === this.MIN_VALUE) {
        return this.ZERO_VALUE;
      }
      if (value === this.MAX_VALUE) {
        return this.MAX_VALUE;
      }
      if (value === this.ZERO_VALUE) {
        return this.MIDDLE_VALUE;
      }
      if (value < this.ZERO_VALUE) {
        return Math.trunc(this.MIDDLE_VALUE - (Math.abs(value) * this.MIDDLE_VALUE) / this.MAX_VALUE);
      }
      if (value > this.ZERO_VALUE) {
        return Math.trunc(this.MIDDLE_VALUE + (value * this.MIDDLE_VALUE) / this.MAX_VALUE);
      }
    }
    return value;
  }
}
